import styled from 'styled-components'

const SkipLink = styled.a`
  position: absolute;
  left: -10000px;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  color: var(--comp-button-primary-solid-icon-color);
  border-radius: 0 0 var(--comp-list-item-corner-radius) var(--comp-list-item-corner-radius);
  padding: 0.5rem 1rem;

  &:focus {
    width: auto;
    height: auto;
    transform: none;
    box-shadow: 0 2px 12px var(--comp-button-primary-solid-background);
    background-color: var(--comp-button-primary-solid-background);
    z-index: 1001;
    left: 0;
  }
`

export function SkipToContent() {
  return (
    <SkipLink href="#main-content" id="skip-to-content" tabIndex={0}>
      Pular para o conteúdo principal
    </SkipLink>
  )
}
